"use client";

import Image from "next/image";
import { useState } from "react";

interface OptimizedImageProps {
  src: string;
  alt: string;
  fill?: boolean;
  priority?: boolean;
  className?: string;
  objectFit?: "cover" | "contain" | "fill" | "scale-down";
  objectPosition?: string;
  blurDataURL?: string;
  width?: number;
  height?: number;
}

export const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  fill = false,
  priority = false,
  className = "",
  objectFit = "cover",
  objectPosition = "top",
  blurDataURL = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 450'%3E%3Crect fill='%23111827' width='800' height='450'/%3E%3Ccircle cx='400' cy='225' r='30' fill='%23374151' opacity='0.5'/%3E%3C/svg%3E",
  width,
  height,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className={`relative ${fill ? "w-full h-full" : "w-full"}`}>
      <Image
        src={src}
        alt={alt}
        fill={fill}
        width={!fill ? width : undefined}
        height={!fill ? height : undefined}
        sizes={fill ? "100vw" : undefined}
        priority={priority}
        loading={priority ? "eager" : "lazy"}
        placeholder="blur"
        blurDataURL={blurDataURL}
        onLoadingComplete={() => setIsLoading(false)}
        className={`${className} ${
          isLoading ? "blur-sm" : "blur-none"
        } transition-all duration-500`}
        style={{
          objectFit: fill ? objectFit : undefined,
          objectPosition: fill ? objectPosition : undefined,
          width: !fill ? "100%" : undefined,
          height: !fill ? "auto" : undefined,
        }}
      />
    </div>
  );
};

export default OptimizedImage;
